import { JwtAction, CommonAction } from 'Actions/index';
import { JwtActionTypes, CommonActionTypes } from 'Actions/ActionTypes/index';
import { IJwt } from 'Store/IJwt';

/**
 * An empty array of camera objects.
 */
const initialState: IJwt = null;

/**
 * A function that maps cameras from a invoked action to the current state.
 * @param {state} - The current state.
 * @param {action} - The action invoked by store.
 */
export const jwt = (state: IJwt = initialState, action: JwtAction | CommonAction) => {
    let newState: IJwt;

    switch (action.type) {
    case JwtActionTypes.SetJwt:
        newState = action.jwt;
        break;
    case JwtActionTypes.ClearJwt:
    case CommonActionTypes.ClearStore:
        newState = initialState;
        break;
    default:
        newState = state;
    }
    return newState;
}